import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseDefaultTextColor } from '../../utils/manager/layout-manager';
import { parseStepCode } from '../../utils/manager/step-manager';

function Step({ step, prepaid, isLowOpacity, cancelled, paid }) {
  const { menuLayout } = useStorage();
  const { t } = useTranslation();
  const classes = useStyles({
    step,
    cancelled,
    isLowOpacity,
    layout: menuLayout,
  });

  const code = useMemo(
    () => parseStepCode(step, prepaid, cancelled, paid),
    [cancelled, step, prepaid]
  );

  return (
    <div className={classes.container}>
      <div className={classes.step}>{t(`order.status.${code}`)}</div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {},
  step: {
    fontSize: layoutDefaults.smallestFontSize,

    color: ({ layout }) => parseDefaultTextColor(layout),
    textShadow: '0px 0px 1px white',
    backgroundColor: ({ step, cancelled, layout }) =>
      cancelled
        ? parseDefaultTextColor(layout, layoutDefaults.smallOpacity)
        : step.color,

    textTransform: 'uppercase',
    padding: '3px 5px 2px 5px',
    border: '1px solid rgba(0, 0, 0, 0.301)',
    whiteSpace: 'nowrap',
    borderRadius: layoutDefaults.smallRadius,

    // backgroundColor: 'gray',
  },
});

export { Step };
